import React from 'react';
import { IconButton } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeContext } from '../../../context/ThemeContext';
import { styled } from '@mui/material/styles';

interface ThemeToggleProps {
  variant?: 'menu' | 'solo';
}

const ToggleButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'menu' | 'solo' }>(({ theme, variant }) => ({
  position: variant === 'menu' ? 'static' : 'fixed',
  top: variant === 'menu' ? undefined : '20px',
  right: variant === 'menu' ? undefined : '20px',
  zIndex: 1000,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)',
  },
}));

const ThemeToggle = React.forwardRef<HTMLButtonElement, ThemeToggleProps>(
  ({ variant, ...otherProps }, ref) => {
    const { darkMode, toggleDarkMode } = useThemeContext();

    return (
      <ToggleButton
        ref={ref}
        onClick={toggleDarkMode}
        color="inherit"
        aria-label="toggle dark mode"
        variant={variant}
        {...otherProps}
      >
        {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
      </ToggleButton>
    );
  }
);

ThemeToggle.displayName = 'ThemeToggle';

export default ThemeToggle;
